/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Filter_DesignInputs */

const en_directory_launch_filter_design = /** @type {(inputs: Directory_Launch_Filter_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const zh_directory_launch_filter_design = /** @type {(inputs: Directory_Launch_Filter_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设计`)
};

/**
* | output |
* | --- |
* | "Design" |
*
* @param {Directory_Launch_Filter_DesignInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_filter_design = /** @type {((inputs?: Directory_Launch_Filter_DesignInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Filter_DesignInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_filter_design(inputs)
	return zh_directory_launch_filter_design(inputs)
});
export { directory_launch_filter_design as "directory.launch.filter_design" }